module.exports = __webpack_public_path__ + "static/media/logo-linkedin.d68f3ffe.svg";